import { schema } from "normalizr";
import { ReplenishmentGroupSchema } from "./replenishment-group";

export const ReplenishmentGroupsSchema = new schema.Array(ReplenishmentGroupSchema);
